"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const genteSlider = document.querySelector(".programa__splide.splide");
        if (!genteSlider) return;

        const splide = new Splide(genteSlider, {
            type: "loop",
            perPage: 3,
            autoplay: false,
            interval: 5000,
            speed: 800,
            pauseOnHover: true,
            arrows: true,
            pagination: false,
            gap: "1.5rem",
            breakpoints: {
                1024: {
                    perPage: 1,
                    arrows: true,
                    pagination: true,
                },
            },
        });

        splide.mount();
    });
}
